import { httpMimeNegotiator } from 'http-header-value/headers.js';
import { HttpError } from '../http-error.js';
import { addResponseHeader } from '../util/add-response-header.js';
/**
 * Dispatches request processing by requested MIME type.
 *
 * Performs [content negotiation] based on [Accept] header. Then calls handler based on negotiation results.
 *
 * Appends `Vary: Accept` header to the response.
 *
 * [content negotiation]: https://developer.mozilla.org/en-US/docs/Web/HTTP/Content_negotiation
 * [Accept]: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Accept
 *
 * @param mimeTypes - Request processing handlers for accepted MIME types.
 * @param fallback - Fallback request handler to call when negotiation failed. Issues 406 (Not Acceptable) by default.
 *
 * @returns New HTTP request processing handler.
 */
export function dispatchByAccepted(mimeTypes, fallback = () => Promise.reject(new HttpError(406))) {
    const negotiator = httpMimeNegotiator(mimeTypes);
    return async ({ request, response, next }) => {
        const { accept = '*/*' } = request.headers;
        const handler = negotiator(accept);
        if (handler) {
            addResponseHeader(response, 'Vary', 'Accept');
            return next(handler.bind(mimeTypes));
        }
        return next(fallback);
    };
}
//# sourceMappingURL=dispatch-by-accepted.handler.js.map